import {KeyboardEvent as ReactKeyboardEvent, UIEvent} from 'react'
import {SetEvent} from 'type/SetCb'

export function isKeyboardEvent<T extends HTMLElement>(event: UIEvent<T> | SetEvent<T>): event is ReactKeyboardEvent<T> {
	return event.nativeEvent instanceof KeyboardEvent
}